import React, { Component } from 'react'
import intl from 'react-intl-universal'
import AuthorisationHandler from '../components/AuthorisationHandler'
import Page from './Page'
import ProfileMenu from '../components/ProfileMenu'
import Input from '../components/Input'
import Loading from '../components/Loading'
import { inject, observer, observable, action, PropTypes } from 'mobx-react/index'
import object_value from '../api/object_value'
import { NotificationManager } from 'react-notifications'
import { update, update_user_image } from '../api'

@inject('user')
@observer
class ProfileSettingsPage extends Component {
  // @observable status = ''
  // @action set_status = (status) => this.status = status

  constructor (props, context) {
    super(props, context)

    this.state = {
      form_class: 'b-form',
      form_edited: false,
      password: null,
      repeat_password: null,
      imagePreviewUrl: '',
      status: '',
      message: ''
    }
  }

  // Enable browser form validation on any input change
  makeValidationVisible = () => {
    // Make validation errors visible
    if (this.state.form_class === 'b-form') {
      this.setState({form_class: this.state.form_class + ' b-form_allow-browser-validation'})
    }
  }

  handleInputChange = async (event) => {
    // console.log('handleInputChange() - event', event)
    const target = event.target
    const value = target
      ? (target.type !== 'checkbox'
        ? target.value
        : target.checkbox)
      : event.value
    const name = target
      ? target.name
      : event.name

    console.log('handleInputChange()', name, value)

    this.setState({
      [name]: value
    })

    if (value) {
      // Show preview
      let file = object_value(event, 'target.files.0')

      if (file) {
        let reader = new FileReader()
        reader.onloadend = async () => {
          await this.setState({
            imagePreviewUrl: reader.result
          })
        }
        reader.readAsDataURL(file)
      }
    } else {
      await this.setState({
        imagePreviewUrl: null
      })
    }
  }

  handlePasswordInput = async (event) => {
    await this.setState({password: event.target.value || null})
  }

  handleRepeatPasswordInput = async (event) => {
    await this.setState({repeat_password: event.target.value || null})
  }

  passwordsMismatch = () => this.state.password !== this.state.repeat_password

  handleChange = async (event) => {
    console.log('handleChange()')
    await this.setState({form_edited: true})
  }

  // Elegant way of binding handler to (this) without `constructor(){ super() }`
  handleSubmit = async (event) => {
    event.preventDefault()

    // Process form data
    const data = new FormData(event.target)

    // Display the key/value pairs
    console.log('handleSubmit() - data')

    const { user } = this.props

    // Delete password if it is mismatched with the repeated one
    if (this.state.password !== this.state.repeat_password) {
      data.delete('password')
    }

    // Clean up
    data.delete('password_repeat')

    // Detach and keep image
    const image = data.get('image')
    data.delete('image')
    console.log('ProfileSettingsPage.js - handleSubmit() - image', image)

    if (image && image.size > 0) {
      const fileData = new FormData()
      fileData.append('image', image)

      const updateImageResponse = await update_user_image(fileData, user.token)
      console.log('ProfileSettingsPage.js - handleSubmit() - updateImageResponse', updateImageResponse)

      if (!updateImageResponse.ok) {
        let message = object_value(updateImageResponse, 'data.message', 'Error')
        // let errors = object_value(updateImageResponse, 'data.errors', {})

        NotificationManager.error(message, 'Error!', 5000)
      } else {
        NotificationManager.success('Your image has been updated', 'Success!', 2500)
      }
    }

    // Do not send unchanged data
    for (let [key, val] of data.entries()) {
      if (typeof user[key] !== 'undefined' && user[key] === val) {
        data.delete(key)
      }
    }
    if (data.get('password') === '') {
      data.delete('password')
    }

    // Send a request
    let response = await update(data, user.token)
    console.log('handleSubmit() - response', response)

    // Fetch updated user data
    if (user.token) {
      user.setToken(user.token)
    }

    // Error
    if (!response.ok) {
      let message = object_value(response, 'data.message', 'Error')
      let errors = object_value(response, 'data.errors', {})

      NotificationManager.error(message, 'Error!', 5000)

      if (errors !== null && typeof errors === 'object') {
        for (let [key, value] of Object.entries(errors)) {
          if (value.length > 0) {
            let fetch_text = ''

            value.forEach(t => {
              fetch_text = fetch_text + t + '<br>'
            })

            message = message + `<br><strong>${key}</strong>:<br>${fetch_text}`
          }
        }
      }

      if (this.refs.UpdateUserForm) { // Prevent a warning - https://stackoverflow.com/a/40969739
        this.setState({
          status: 'error',
          message
        })
      }

      return false
    }

    // Notify
    NotificationManager.success('Your information has been updated', 'Success!', 2500)

    // Success
    if (this.refs.UpdateUserForm) {
      this.setState({
        status: 'success',
        form_edited: false
      })
    }
  }

  render () {
    const {user} = this.props
    console.log('render() - user', user)

    let image_url = this.state.imagePreviewUrl || user.image_url
    let image_style = image_url
      ? { backgroundImage: 'url(' + image_url + ')' }
      : {}

    return (
      <AuthorisationHandler>
        <Page title='Settings'>
          <section className='b-profile'>
            <div className='b-profile-inner'>

              <ProfileMenu />

              <div className='b-profile-main'>
                <h3 className='b-profile-title'>{intl.get('Settings')}</h3>

                <form ref="UpdateUserForm"
                      className={this.state.form_class}
                      onChange={this.handleChange}
                      onSubmit={this.handleSubmit}>

                  <div className='b-form-row'>
                    <div className='b-form-item b-form-item_x'>
                      <div className='b-form-item-input-user-image'>
                        <div className='b-form-item-input-user-image-preview' style={image_style} />
                        <label htmlFor='image'
                               className='b-button'>Foto hochladen</label>
                        <input id='image'
                               name='image'
                               type='file'
                               accept='image/*'
                               onChange={this.handleInputChange}
                        />
                      </div>
                    </div>
                  </div>

                  <div className='b-form-row'>
                    <div className='b-form-item b-form-item_x'>
                      <Input className='b-form-item-input-text'
                             id='email'
                             name='email'
                             type='email'
                             defaultValue={user.email}
                             required />
                      <label className='b-form-item-label' htmlFor='email'>
                        {intl.get('E-Mail')}
                      </label>
                    </div>

                    <div className='b-form-item' />
                  </div>

                  {(!user.google_id_token && !user.facebook_user_id) &&
                  <div className='b-form-row'>
                    <div className='b-form-item b-form-item_x'>
                      <Input className='b-form-item-input-text'
                             minLength={8}
                             type='password'
                             id='password'
                             name='password'
                             onChange={this.handlePasswordInput}
                             required={this.passwordsMismatch()} />
                      <label className='b-form-item-label'
                             htmlFor='password'>
                        {intl.get('New Password')}
                      </label>
                    </div>

                    <div className={!this.passwordsMismatch()
                      ? 'b-form-item b-form-item_x'
                      : 'b-form-item b-form-item_x is_invalid'}>
                      <Input className='b-form-item-input-text'
                             minLength={8}
                             type='password'
                             id='password_repeat'
                             name='password_repeat'
                             disabled={!this.state.password}
                             onChange={this.handleRepeatPasswordInput}  />
                      <label className='b-form-item-label'
                             htmlFor='password_repeat'>
                        {intl.get('Repeat new password')}
                      </label>

                      {this.passwordsMismatch() &&
                      <div className='b-form-item-input-message'>
                        {intl.get('Passwords mismatch')}
                      </div>}
                    </div>
                  </div>}

                  <div className='b-form-row'>
                    <div className='b-form-item b-form-item_x'>
                      <Input className='b-form-item-input-text'
                             id='prename'
                             name='prename'
                             defaultValue={user.prename}
                             required />
                      <label className='b-form-item-label'
                             htmlFor='prename'>
                        {intl.get('First name')}
                      </label>
                      <div className='b-form-item-mark'>Seen by public</div>
                    </div>

                    <div className='b-form-item b-form-item_x'>
                      <Input className='b-form-item-input-text'
                             id='surname'
                             name='surname'
                             defaultValue={user.surname}
                             required />
                      <label className='b-form-item-label'
                             htmlFor='surname'>
                        {intl.get('Last name')}
                      </label>
                    </div>
                  </div>

                  <div className='b-form-row'>
                    <div className='b-form-item b-form-item_x'>
                      <label className='b-form-item-radio'>
                        <Input name='gender'
                               type='radio'
                               value='f'
                               defaultChecked={user.gender === 'f' ? 'checked' : ''} />
                        <span>{intl.get('Female')}</span>
                      </label>
                    </div>

                    <div className='b-form-item b-form-item_x'>
                      <label className='b-form-item-radio'>
                        <Input name='gender'
                               type='radio'
                               value='m'
                               defaultChecked={user.gender === 'm' ? 'checked' : ''} />
                        <span>{intl.get('Male')}</span>
                      </label>
                    </div>

                    <div className='b-form-item' />
                    <div className='b-form-item' />
                    <div className='b-form-item' />
                    <div className='b-form-item' />
                  </div>

                  <div className='b-form-row'>
                    <div className='b-form-item b-form-item_x'>
                      <Input className='b-form-item-input-text'
                             id='city'
                             name='city'
                             defaultValue={user.city}
                             required />
                      <label className='b-form-item-label'
                             htmlFor='city'>
                        {intl.get('City')}
                      </label>
                    </div>

                    <div className='b-form-item b-form-item_x'>
                      <Input className='b-form-item-input-text'
                             id='job'
                             name='job'
                             defaultValue={user.job} />
                      <label className='b-form-item-label'
                             htmlFor='job'>
                        {intl.get('Job')}
                      </label>
                    </div>
                  </div>

                  <div className='b-form-row'>
                    <div className='b-form-item b-form-item_x'>
                      <Input element_type='textarea'
                             className='b-form-item-input-text'
                             id='description'
                             name='description'
                             defaultValue={user.description} />
                      <label className='b-form-item-label'
                             htmlFor='description'>
                        {intl.get('Description')}
                      </label>
                    </div>

                    <div className='b-form-item' />
                  </div>

                  <button className='b-button b-button_primary b-button_x'
                          disabled={!this.state.form_edited}>Speichern</button>
                </form>
              </div>
            </div>
          </section>
        </Page>
      </AuthorisationHandler>
    )
  }
}

ProfileSettingsPage.propTypes = {
  user: PropTypes.observableObject
}

export default ProfileSettingsPage



// WEBPACK FOOTER //
// ./src/containers/ProfileSettingsPage.js